import classNames from 'classnames';
import React, { Component } from 'react';
import ReactModal from 'react-modal';
import IconButton from "../../../../common/buttons/icon-button/IconButton";
import styles from './DeleteSecurityGroupModal.module.scss';
import { IDeleteSecurityGroupModalProps } from './IDeleteSecurityGroupModalProps';
import { IDeleteSecurityGroupModalState } from "./IDeleteSecurityGroupModalState";

class DeleteSecurityGroupModal extends Component<IDeleteSecurityGroupModalProps, IDeleteSecurityGroupModalState> {

  private static removeDialogIndex = 100;

  constructor(props: IDeleteSecurityGroupModalProps) {
    super(props);

    this.state = {
      dialogId: 'delete_security_group_dialog_' + (DeleteSecurityGroupModal.removeDialogIndex++)
    };

    this.onConfirmClicked = this.onConfirmClicked.bind(this);
  }

  render() {
    return (
      <ReactModal
        appElement={document.getElementById('root') as HTMLElement}
        isOpen={this.props.showDialog}
        id={this.state.dialogId}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        className={classNames([styles.dialog, "shadow p-4"])}
      >
        <h2>Delete user group</h2>

        <p>Are you sure you want to delete user group <b className={"text-break"}>{this.props.groupNameToDelete}</b>?</p>

        <div className="d-flex justify-content-end">
          <IconButton onClick={this.onConfirmClicked} variant="outline-primary" title="Delete"
                      styles={{marginRight: '1em'}}/>
          <IconButton onClick={this.props.onCancel} variant="outline-primary" title="Cancel"/>
        </div>
      </ReactModal>
    );
  }

  onConfirmClicked() {
    if (this.props.onConfirm !== undefined && this.props.onConfirm !== null) {
      this.props.onConfirm(this.props.groupIdToDelete ?? 0);
    }
  }
}

export default DeleteSecurityGroupModal;